<!--
 * @Author: your name
 * @Date: 2020-06-15 13:36:46
 * @LastEditTime: 2020-06-29 18:31:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /saas-patient-vue/src/view/service/service.vue
--> 
<template>
  <div
    :class="['service-agreement', {'title': isTitle}]">
    <van-nav-bar
      v-if="isTitle"
      :title="title[num]" 
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
    <secretAgreement v-if="num === 0" />
    <userServiceAgreement v-if="num === 1" />
    <lawAgreement v-if="num === 2" />
    <hospitalAgreement v-if="num === 3" />
    <inquiryAgreement v-if="num === 4" />
    <mallAgreement v-if="num===5"/>
    <inquiryHyAgreement v-if="num===6" />
  </div>
</template>

<script>
import lawAgreement from '@/components/service/lawAgreement';
import secretAgreement from '@/components/service/secretAgreement';
import userServiceAgreement from '@/components/service/userServiceAgreement';
import hospitalAgreement from '@/components/service/hospitalAgreement';
import inquiryAgreement from '@/components/service/inquiryAgreement';
import mallAgreement from '@/components/service/mallAgreement';
import inquiryHyAgreement from '@/components/service/inquiryHyAgreement';
export default {
  data() {
    return {
      title: ['隐私政策', '荷叶健康用户服务协议', '法律声明', '宜贰叁互联网医院服务协议', '问诊知情同意书','荷叶健康（商城）服务协议','荷叶健康（问诊）服务协议']
    };
  },
  created() {
    console.log("screen", window.screen.width)
  },
  computed: {
    num() {
      let num = parseInt(this.$route.query.num) || 0;
      if (num && num >= this.title.length) {
        num = 0
      }
      return num;
    },
    isTitle() {
      if (this.$route.query.title) {
        return true;
      }
      return false;
    }
  },
  methods: {
    onClickLeft() {
      if (this.$route.query.type === 'inquiryInfo') {
        this.$router.replace({
          path: 'interrogationInfoText',
          query: {
            type: 'agreement'
          }
        })
      } else {
        this.$router.back(-1)
      }
    }
  },
  components: {
    lawAgreement,
    secretAgreement,
    userServiceAgreement,
    hospitalAgreement,
    inquiryAgreement,
    mallAgreement,
    inquiryHyAgreement
  },
};
</script>

<style scoped lang="scss">
  .service-agreement {
    &.title {
      padding: 50px 10px;
    }
  }
  .service-agreement /deep/ {
    padding: 10px;
    h4 {
      font-size: 16px;
    }
    h5 {
      font-size: 14px;
    }
    p {
      font-size: 14px;
      text-indent: 2em;
    }
    @media screen and (min-width: 1000px) {
      h4 {
        font-size: 8px;
      }
      h5 {
        font-size: 6px;
      }
      p {
        text-indent: 2em;
        font-size: 6px;
      }
    }
  }
</style>
